export default [
  {
    component: 'TitleBlock',
    orientation: 'center',
    content: {
      title: '<span class="title__line"><span class="title__letter">T</span><span class="title__letter">H</span><span class="title__letter">E</span><span class="title__letter"> </span><span class="title__letter">C</span><span class="title__letter">O</span><span class="title__letter">N</span><span class="title__letter">D</span><span class="title__letter">O</span></span><br /><span class="title__line"><span class="title__letter">T</span><span class="title__letter">-</span><span class="title__letter">S</span><span class="title__letter">H</span><span class="title__letter">I</span><span class="title__letter">R</span><span class="title__letter">T</span><span class="title__letter">S</span>',
    },
  },
  {
    component: 'VideoBlock',
    mode: 'contain',
    content: {
      video: '/static/video/main.mp4',
      resource: 'videoMain',
      eyelet: 'Wynwood Collection',
      subtitle: '100% PURE COTTON',
    },
  },
  {
    component: 'TextBlock',
    orientation: 'right',
    content: {
      subtitle: 'Highest end. Shockingly stylish. Classiest class. Excessively Exclusive. 143 one-of-a-kind T-shirts.',
      text: 'A unique collection solely composed of 143 accurately machine sewn T-shirts inspired by Miami’s artistic and cultural hive: Wynwood.<br />Made of the purest cotton and extremely easy to fold, each piece is for all intents and purposes the definitive garment.',
    },
  },
  {
    component: 'TitleBlock',
    orientation: 'left',
    hasDisclaimer: true,
    content: {
      title: '<span class="title__line">BUY A T-SHIRT</span><br /><span class="title__line">AND GET</span><br /><span class="title__line">AN APARTMENT</span><br /><span class="title__line">FOR FREE*.</span></span>',
    },
  },
  {
    component: 'TextBlock',
    orientation: 'right',
    content: [
      {
        title: 'S.M.L.',
        text: 'Size:<br />Small, Medium, Large.<br /><br />Value:<br />Short, Medium, Long Term.',
      },
      {
        title: 'Be Dynamic, Be Brave.',
        text: 'Become an integral part of a selected group of individuals who are certain of what they want. And that’s exactly what they’ll take.',
      },
    ],
  },
  {
    component: 'VideoBlock',
    mode: 'half',
    content: {
      video: '/static/video/third.mp4',
      resource: 'videoThird',
      eyelet: 'Wynwood Collection',
      subtitle: 'IRONABLE AND ACCURATELY MACHINE SEWN',
    },
  },
  {
    component: 'TextBlock',
    orientation: 'right',
    content: {
      title: 'MADE TO BE WORN.',
      text: 'Is there a better place to dress this unique piece of garment than the most inclusive and creative area in America? We don’t think so.<br /><br />But people like us don\'t need to worry. And there\'s no need to.<br />This collection is so exclusive that customers will receive an apartment in Miami’s most fashionable, on-the-rise neighborhood as a freebie.',
    },
  },
  {
    component: 'MarqueeBlock',
    direction: 'left',
    content: {
      title: 'DIESEL WYNWOOD - PRE-SALE SEASON',
    },
  },
  {
    component: 'ImagesBlock',
    content: [
      {
        content: {
          image: '/static/images/look_book/diesel_wynwood_img3.jpg',
          resource: 'productOne',
          title: 'T-SHIRT A1-L4<br />STUDIO<br /><span class="vhs">S SIZE</span>',
          price: '$ 399.000',
        },
      },
      {
        content: {
          image: '/static/images/look_book/diesel_wynwood_img4.jpg',
          resource: 'productTwo',
          title: 'T-SHIRT D6-L4<br />2 BDRM<br /><span class="vhs">M SIZE</span>',
          price: '$ 949.000',
        },
      },
    ],
  },
  {
    component: 'ImagesBlock',
    content: [
      {
        content: {
          image: '/static/images/look_book/diesel_wynwood_img5.jpg',
          resource: 'productThree',
          title: 'T-SHIRT E4-L4<br />2 BDRM + DEN<br /><span class="vhs">L SIZE</span>',
          price: '$ 1.399.000',
        },
      },
      {
        content: {
          image: '/static/images/look_book/diesel_wynwood_img7.jpg',
          resource: 'productFour',
          title: 'T-SHIRT F1-L6<br />3 BDRM<br /><span class="vhs">XL SIZE</span>',
          price: '$ 1.599.000',
        },
      },
    ],
  },
  {
    component: 'VideoBlock',
    mode: 'padding',
    content: {
      title: 'T-SHIRT F2-L8<br />PENTHOUSE<br /><span class="vhs">XXL SIZE</span>',
      price: '$ 5.500.000',
      video: '/static/video/second.mp4',
      resource: 'videoSecond',
    },
  },
  {
    component: 'MarqueeBlock',
    direction: 'right',
    content: {
      title: 'THE MOST EXPENSIVE T-SHIRTS IN THE WORLD',
    },
  },
  {
    component: 'TitleBlock',
    orientation: 'right',
    content: {
      title: '<span class="title__line">SUCH</span><br /><span class="title__line">IRRATIONAL</span><br /><span class="title__line">QUALITY,</span><br /><span class="title__line">THE PRICE TAG</span><br /><span class="title__line">LOOKS SANE</span><br /><span class="title__line">IN COMPARISON.</span>',
    },
  },
  {
    component: 'TextBlock',
    orientation: 'left',
    content: {
      subtitle: 'Accept No Compromises.<br />Only the Very Best is the Answer.',
      text: 'Art as well as business, a new take on what Urban Lifestyle means.<br>A success that mingles metropolitan scapes with natural overtones.<br />The essence of Diesel: a total luxury collection of comfort and cutting edge Fashion.',
    },
  },
  {
    component: 'VideoBlock',
    mode: 'padding',
    content: {
      video: '/static/video/fourth.mp4',
      resource: 'videoFourth',
      subtitle: '143 ONE OF A KIND T-SHIRTS',
    },
  },
  {
    component: 'TitleBlock',
    orientation: 'huge',
    content: {
      title: '<span class="title__line"><span class="title__letter">C</span><span class="title__letter">O</span><span class="title__letter">N</span><span class="title__letter">T</span><span class="title__letter">A</span><span class="title__letter">C</span><span class="title__letter">T</span></span>',
    },
  },
];
